import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Select from 'antd/lib/select';

import { IconCloudStorm } from '@tabler/icons-react';

import styles from './weather-conditions-card.module.css';

const { Option } = Select;

export default function WeatherConditionsCard({ setSelectedRegion, loading, regions, weatherData, renderCurrentWeather, renderHourlyForecast }) {
    return (
        <Box className={styles.weatherSection}>
            <div className={styles.sectionHeader}>
              <Typography variant="h6">Weather Conditions</Typography>
              <Select
                placeholder="Select Region"
                style={{ width: '50%' }}
                onChange={value => setSelectedRegion(value)}
                loading={loading.weather}
              >
                {regions.map(region => (
                  <Option key={region} value={region}>{region}</Option>
                ))}
              </Select>
            </div>
            <div className={styles.weatherContent}>
              {loading.weather ? (
                <div className={styles.weatherLoading}>
                  <IconCloudStorm size={24} className={styles.loadingIcon} />
                  <Typography>Loading weather data...</Typography>
                </div>
              ) : weatherData ? (
                <>
                  {renderCurrentWeather()}
                  {renderHourlyForecast()}
                </>
              ) : (
                <div className={styles.emptyState}>
                  <IconCloudStorm size={24} />
                  <Typography>Select a region to view weather data</Typography>
                </div>
              )}
            </div>
          </Box>
    )
}